import Svg, { Path } from "react-native-svg";
import { GetProps } from "tamagui";

const Pills = ({ color, ...props }: GetProps<typeof Svg>) => (
  <Svg width={24} height={24} viewBox="0 0 24 24" fill="none" {...props}>
    <g clip-path="url(#clip0_6016_1862)">
      <Path
        d="M23 5C23 7.20914 21.2091 9 19 9C16.7909 9 15 7.20914 15 5M23 5C23 2.79086 21.2091 1 19 1C16.7909 1 15 2.79086 15 5M23 5H15M6.1453 17.8547L12.8547 11.1453M6.1453 17.8547L9.90103 21.6104C11.7538 23.4632 14.7577 23.4632 16.6104 21.6104C18.4632 19.7577 18.4632 16.7538 16.6104 14.901L12.8547 11.1453M6.1453 17.8547L2.38957 14.099C0.536813 12.2462 0.536811 9.24232 2.38956 7.38956C4.24231 5.53681 7.24622 5.53681 9.09897 7.38956L12.8547 11.1453"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_6016_1862">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </Svg>
);

export default Pills;
